export default {
  title: "車両テスト",
  eventVideos: {
    title: "危険挙動ビデオ",
    cameraType: {
      cameraFront: "カメラ1",
      cameraRear: "カメラ2",
      cameraInner: "カメラ3",
      cameraSide: "カメラ4",
    },
    eventType: {
      1: "急減速",
      2: "急加速",
      3: "急旋回",
      4: "急旋回",
      5: "速度超過",
    },
  },
  map: {
    title: "位置情報",
    waitingLocationInfo: "位置情報の受信を待機しています...",
    infoWindow: {
      dataTransmission: {
        title: "データ送信日時"
      },
      addressLoading: "ロード中...",
      getAddress: "住所を表示"
    }
  },
  errors: {
    getVehicle: "車両情報の取得に失敗しました。",
    usingDocomap: "対象運営会社はDoCoMAPを使用していますので、DoCoMAPより位置情報をご確認ください。",
    getDevice: "車両に接続されたデバイスが取得できませんでした。車両情報をご確認ください。",
    noEventVideo:"本日記録された危険挙動ビデオはありません。",
    getVideos: "危険挙動ビデオの取得に失敗しました。",
    getLatestPosition: "最新の位置情報の取得に失敗しました。",
    getAddress: "住所の取得に失敗しました。"
  }
};